// extracted by css-extract-rspack-plugin
export default {"Text":"InputLabel-module__Text__pL1lZ","Box":"InputLabel-module__Box__KLaaz","Box_1":"InputLabel-module__Box_1__gBFnM"};